var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrafficControlPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2423_365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53925 0.580664C7.64928 0.234849 7.97045 0 8.33335 0H11.6667C12.0296 0 12.3508 0.234849 12.4608 0.580664L18.1094 18.3333H19.1667C19.6269 18.3333 20 18.7064 20 19.1667C20 19.6269 19.6269 20 19.1667 20H17.5191C17.5062 20.0003 17.4934 20.0003 17.4806 20H2.51948C2.50668 20.0003 2.49384 20.0003 2.48098 20H0.833333C0.373096 20 0 19.6269 0 19.1667C0 18.7064 0.373096 18.3333 0.833333 18.3333H1.89067L7.53925 0.580664ZM3.63967 18.3333H16.3604L14.7695 13.3333H5.23058L3.63967 18.3333ZM13.4437 9.16667L14.2392 11.6667H5.76088L6.55634 9.16667H13.4437ZM12.9134 7.5H7.08664L8.9427 1.66667H11.0573L12.9134 7.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2423_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficControlPoint);
export default __webpack_public_path__ + "static/media/traffic_control_point.4b947e1c32db2a95b21e42cee719bdff.svg";
export { ForwardRef as ReactComponent };